import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import CurrencyConverter from '../CurrencyConverter';
import messages from '../../locale/jsonMessages';
import { getOptionLineLabel, sumOptionLines } from '../../helpers/bookingOptionsPresentation';
import cs from '../commonStyle.css';
import s from './OptionLines.css';

// "Options et services" rows of a bill: one row per option (label with days or flat fee, amount),
// optional subtotal and the delivery location. Used by every bill / receipt / admin screen so they all agree.
function OptionLines({ lines, currency, showTitle = true, showSubtotal = true, showLocation = false, showContactNote = false, titleMessage, className }) {
  const { formatMessage } = useIntl();
  if (!Array.isArray(lines) || lines.length === 0) return null;
  const delivery = lines.find((line) => line.code === 'delivery' && line.userInput);

  return (
    <div className={cx(s.block, className)}>
      {showTitle && (
        <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, s.title)}>
          {formatMessage(titleMessage || messages.boTitle)}
        </div>
      )}
      {lines.map((line, index) => (
        <div key={line.id || `${line.code}-${index}`} className={cx(cs.dataTableGrid, cs.paymentDivider)}>
          <div className={cx(cs.commonSmallText16, cs.textStart)}>{getOptionLineLabel(line, formatMessage)}</div>
          <div className={cx(cs.commonSmallText16, cs.textEnd)}>
            <CurrencyConverter amount={Number(line.amount) || 0} from={currency} />
          </div>
        </div>
      ))}
      {showLocation && delivery && (
        <div className={cx(s.location, cs.commonSmallText16)}>
          <strong>{formatMessage(messages.boDeliveryLocationShown)}:</strong> <span className={s.locationValue}>{delivery.userInput}</span>
        </div>
      )}
      {showContactNote && (
        <p className={s.contactNote} role="note">{formatMessage(messages.boOwnerWillContact)}</p>
      )}
      {showSubtotal && (
        <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
          <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textStart)}>{formatMessage(messages.boSubtotalOptions)}</div>
          <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textEnd)}>
            <CurrencyConverter amount={sumOptionLines(lines)} from={currency} />
          </div>
        </div>
      )}
    </div>
  );
}

OptionLines.propTypes = {
  lines: PropTypes.array,
  currency: PropTypes.string,
  showTitle: PropTypes.bool,
  showSubtotal: PropTypes.bool,
  showLocation: PropTypes.bool,
};

export default withStyles(cs, s)(OptionLines);
